<template>
  <div class="page-container content-430">
    <div class="search-block">
      <span>学生姓名：</span>
      <Input
        v-model="studentsName"
        placeholder="请输入"
        style="width: 300px;margin-left:8px;margin-right:16px;"
      ></Input>
      <Button type="primary" @click="handleSearch">查询</Button>
    </div>
    <div class="table-box">
      <Table
        ref="timeTable"
        border
        :columns="tableColumn"
        :data="tableData"
      ></Table>
      <Page
        :total="pageInfo.total"
        show-total
        :current="pageInfo.pageNum"
        class="page-right"
        @on-change="handlePageChange"
      ></Page>
    </div>
  </div>
</template>
<script>
import courseSchedulCenter from "@/request/courseSchedulCenter/index.js";
export default {
  data() {
    // 课班详情表状态\n     * 0未开始1未考勤2签到3签退4请假5缺席6停课
    const signStateObj = {
      "0": "未开始",
      "1": "未考勤",
      "2": "已签到",
      "3": "已签退",
      "4": "请假",
      "5": "缺席",
      "6": "停课"
    };
    return {
      studentsName: "", // 学生姓名
      tableColumn: [
        {
          title: "学生姓名",
          key: "signPersonName",
          minWidth: 120,
          align: "center"
        },
        {
          title: "考勤状态",
          key: "signState",
          minWidth: 120,
          align: "center",
          render: (h, params) => {
            return h("div", [`${signStateObj[params.row.signState]}`]);
          }
        },
        {
          title: "签到时间",
          key: "signTime",
          minWidth: 120,
          align: "center"
        },
        {
          title: "签退时间",
          key: "signoutTime",
          minWidth: 120,
          align: "center"
        },
        {
          title: "是否请假",
          key: "isLeave",
          minWidth: 120,
          align: "center",
          render: (h, params) => {
            return h("div", [
              `${Number(params.row.signState) === 4 ? "是" : "否"}`
            ]);
          }
        }
      ],
      tableData: [],
      pageInfo: {
        total: 1,
        pageSize: 10,
        pageNum: 1
      },
      detailId: ""
    };
  },
  created() {
    this.detailId = this.$route.query.detailId || "";
    this.getSignRecord();
  },
  methods: {
    async getSignRecord() {
      const params = {
        detailId: this.detailId,
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize,
        studentName: this.studentsName ? this.studentsName : null
      };
      const res = await courseSchedulCenter.getClassSignRecordApi(params);
      if (res.status === 200) {
        this.tableData = res.message.list;
        this.pageInfo.total = Number(res.message.total);
      }
    },
    // 点击查询
    handleSearch() {
      this.pageInfo.pageNum = 1;
      this.getSignRecord();
    },
    handlePageChange(page) {
      this.pageInfo.pageNum = page;
      this.getSignRecord();
    }
  }
};
</script>
<style lang="scss" scoped>
.table-box {
  margin-top: 16px;
}
.page-right {
  text-align: right;
  margin-top: 16px;
}
</style>
